import { create } from 'zustand'

interface User {
  id: number
  email: string
  nickname: string
  gender: string
  birth_date: string
  birth_time: string | null
  birth_type: string
  mbti: string | null
  blood_type: string | null
  is_admin: boolean
}

interface AuthState {
  user: User | null
  isAuthenticated: boolean
  setUser: (user: User) => void
  logout: () => void
}

const hasWindow = typeof window !== 'undefined'
const getToken = (key: string) => {
  if (!hasWindow) return null
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: !!getToken('access_token'),
  setUser: (user) => set({ user, isAuthenticated: true }),
  logout: () => {
    if (hasWindow) {
      try {
        window.localStorage.removeItem('access_token')
        window.localStorage.removeItem('refresh_token')
      } catch {
        // ignore
      }
    }
    set({ user: null, isAuthenticated: false })
  },
}))
